var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleHeader',{attrs:{"image":_vm.image,"myzone":""}},[_c('CycleHeroCardMyzone',{attrs:{"heading":_vm.heading,"name-data":_vm.personalData,"empty-name":_vm.emptyName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }